import service from '@/store/services/checkout-service';
import axios from 'axios';

const state = {
  loading: false,
};

const mutations = {
  SET_LOADING: (state, payload) => {
    state.loading = payload;
  },
};

const actions = {
  stripeCheckout({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = params;
    payload.session_id = currentSession;

    return service
      .stripeCheckout(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  stripePaymentIntent({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = params;
    payload.session_id = currentSession;

    return service
      .stripePaymentIntent(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  stripePaymentIntentUpdate({ commit, dispatch }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    let payload = params;
    payload.session_id = currentSession;

    return service
      .stripePaymentIntentUpdate(payload)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
        }
        return res;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const getters = {
};

const checkout = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default checkout;
